import slice from "./productStoreFitSlice";

export default slice.reducer;
